// Maps the free-text `clientCountry` string (inconsistent in the data — "Saudi" vs "Saudi Arabia")
// to a 2-letter code for <FlagIcon>. Falls back to no flag rather than guessing.
const CODE_BY_KEYWORD = [
  [/qatar/i, 'qa'],
  [/u\.?a\.?e|emirates/i, 'ae'],
  [/saudi/i, 'sa'],
  [/kuwait/i, 'kw'],
  [/bahrain/i, 'bh'],
  [/oman/i, 'om'],
  [/kenya/i, 'ke'], // origin country, not a placement destination — used by PhoneInput's +254 prefix
];

export function countryFlagCode(country) {
  if (!country) return null;
  const hit = CODE_BY_KEYWORD.find(([re]) => re.test(country));
  return hit ? hit[1] : null;
}
